import { Effect, Reducer, Subscription } from 'umi';
import {
  REGISTER_TOTAL_NEW_USERS,
  ACTIVE_METRICS,
  ACTIVE_USER_ROLE,
  ACTIVE_OVERALL_ONLINE_TIME,
  ENGAGEMENT_RETENTION_TABLE,
  ENGAGEMENT_RETENTION_TREND,
  REGISTER_NEW_DISTRIBUTION,
  ENGAGEMENT_CHURN_USERS_DETAILS,
  ACTIVE_DEGREE_WEEK,
  ACTIVE_DEGREE_BIWEEK,
  ACTIVE_COUNTRY_REGION_ZONE,
  REGISTER_USERS_DISTRIBUTION,
  ACTIVE_DEGREE_MONTH
} from './_config/filterDvaKey';

export const namespace = 'engagement';

const EngagementModel = {
  namespace: namespace,
  state: {
    data: {}
  },

  effects: {
    // 获取游戏列表
    *getTotalNewUsersFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveTotalNewUsers", payload: { [REGISTER_TOTAL_NEW_USERS]: payload } });
      } catch (e) {
        yield put({
          type: "saveTotalNewUsers", payload: {

          }
        });
      }
    },
    *getRegisterDistributionFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveRegisterUsers", payload: { [REGISTER_USERS_DISTRIBUTION]: payload } });
      } catch (e) {
        yield put({
          type: "saveRegisterUsers", payload: {

          }
        });
      }
    },
    *getActiveMetricsFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveActiveMetrics", payload: { [ACTIVE_METRICS]: payload } });
      } catch (e) {
        yield put({
          type: "saveActiveMetrics", payload: {

          }
        });
      }
    },
    *getActiveUserRoleFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveActiveUserRole", payload: { [ACTIVE_USER_ROLE]: payload } });
      } catch (e) {
        yield put({
          type: "saveActiveUserRole", payload: {

          }
        });
      }
    },
    *getOverallOnlineTimeDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveOverallOnlineTime", payload: { [ACTIVE_OVERALL_ONLINE_TIME]: payload } });
      } catch (e) {
        yield put({
          type: "saveOverallOnlineTime", payload: {}
        });
      }
    },
    *getActiveDegreeWeekFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveActiveDegreeWeek", payload: { [ACTIVE_DEGREE_WEEK]: payload } });
      } catch (e) {
        yield put({
          type: "saveActiveDegreeWeek", payload: {

          }
        });
      }
    },
    *getActiveDegreeBiWeekFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveActiveDegreeBiWeek", payload: { [ACTIVE_DEGREE_BIWEEK]: payload } });
      } catch (e) {
        yield put({
          type: "saveActiveDegreeBiWeek", payload: {

          }
        });
      }
    },
    *getActiveDegreeMonthFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveActiveDegreeMonth", payload: { [ACTIVE_DEGREE_MONTH]: payload } });
      } catch (e) {
        yield put({
          type: "saveActiveDegreeMonth", payload: {

          }
        });
      }
    },
    *getRetentionDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveEngagementRetention", payload: { [ENGAGEMENT_RETENTION_TABLE]: payload } });
      } catch (e) {
        yield put({
          type: "saveEngagementRetention", payload: {
          }
        });
      }
    },
    *getRetentionTrendDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveEngagementRetentionTrend", payload: { [ENGAGEMENT_RETENTION_TREND]: payload } });
      } catch (e) {
        yield put({
          type: "saveEngagementRetentionTrend", payload: {
          }
        });
      }
    },
    *getChurnUsersDetailDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveEngagementChurnUsersDetailData", payload: { [ENGAGEMENT_CHURN_USERS_DETAILS]: payload } });
      } catch (e) {
        yield put({
          type: "saveEngagementChurnUsersDetailData", payload: {
          }
        });
      }
    },
    *getReturnUsersDetailDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveEngagementReturnUsersDetailData", payload: { [ENGAGEMENT_CHURN_USERS_DETAILS]: payload } });
      } catch (e) {
        yield put({
          type: "saveEngagementReturnUsersDetailData", payload: {
          }
        });
      }
    },
    *getRegisterBreakDownDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveRegisterBreakDownData", payload: { [REGISTER_NEW_DISTRIBUTION]: payload } });
      } catch (e) {
        yield put({
          type: "saveRegisterBreakDownData", payload: {
          }
        });
      }
    },
    *getActiveBreakDownDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveActiveBreakDownData", payload: { [ACTIVE_COUNTRY_REGION_ZONE]: payload } });
      } catch (e) {
        yield put({
          type: "saveActiveBreakDownData", payload: {
          }
        });
      }
    },
  },
  reducers: {
    saveRegisterUsers(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveTotalNewUsers(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveActiveMetrics(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveActiveUserRole(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveOverallOnlineTime(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveActiveDegreeWeek(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveActiveDegreeBiWeek(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveActiveDegreeMonth(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveEngagementRetention(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveEngagementRetentionTrend(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveEngagementChurnUsersDetailData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveEngagementReturnUsersDetailData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveRegisterBreakDownData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    saveActiveBreakDownData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },

  }
};

export default EngagementModel;
